import { useContext, useState, useEffect, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { AuthContext } from "../../../contexts/AuthContext";
import { tempUrl, useStateContext } from "../../../contexts/ContextProvider";
import { Loader, usePagination, ButtonModifier } from "../../../components";
import { formatDate, formatTime } from "../../../constants/helper";
import { ShowTableMutasiStokChild } from "../../../components/ShowTable";
import { Container, Card, Form, Row, Col } from "react-bootstrap";
import { Box, Button, ButtonGroup } from "@mui/material";
import jsPDF from "jspdf";
import { NumericFormat } from "react-number-format";
import PrintIcon from "@mui/icons-material/Print";
import SearchIcon from "@mui/icons-material/Search";
import useScreenWidth from "../../../hooks/useScreenWidth";

const TampilMutasiStok = () => {
  const screenSize = useScreenWidth();
  const reportTemplateRef = useRef(null);
  const { user, dispatch, setting } = useContext(AuthContext);
  const [previewPdf, setPreviewPdf] = useState(false);
  const [isPost, setIsPost] = useState("");
  const [createdAtHour, setCreatedAtHour] = useState("");

  // Data Mutasi Stok
  const [noBuktiMutasiStok, setNoBuktiMutasiStok] = useState("");
  const [tglMutasiStok, setTglMutasiStok] = useState("");
  const [jumlahItem, setJumlahItem] = useState("0");
  const [kodeCOA, setKodeCOA] = useState("");
  const [keterangan, setKeterangan] = useState("");

  // Data Total
  const [total, setTotal] = useState("0");

  const [mutasiStoksChildData, setMutasiStoksChildData] = useState([]);
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  let today = new Date();
  let isEditableManager = user.tipeUser !== "ADMIN" && isPost === false;
  let isEditableAdmin = true;
  // let isEditableAdmin =
  //   user.tipeUser === "ADMIN" &&
  //   tglMutasiStokDate?.getFullYear() === today.getFullYear() &&
  //   tglMutasiStokDate?.getMonth() === today.getMonth() &&
  //   tglMutasiStokDate?.getDate() === today.getDate() &&
  //   isPost === false;
  let isEditable = isEditableManager || isEditableAdmin;

  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  let [page, setPage] = useState(1);
  const PER_PAGE = 20;

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  // Get current posts
  const indexOfLastPost = page * PER_PAGE;
  const indexOfFirstPost = indexOfLastPost - PER_PAGE;
  const currentPosts = mutasiStoksChildData.slice(
    indexOfFirstPost,
    indexOfLastPost
  );

  const count = Math.ceil(mutasiStoksChildData.length / PER_PAGE);
  const _DATA = usePagination(mutasiStoksChildData, PER_PAGE);

  const handleChange = (e, p) => {
    setPage(p);
    _DATA.jump(p);
  };

  useEffect(() => {
    getMutasiStokById();
  }, []);

  const getMutasiStokById = async () => {
    setLoading(true);
    const response = await axios.post(`${tempUrl}/mutasiStoks/${id}`, {
      _id: user.id,
      token: user.token,
    });
    setIsPost(response.data.isPost);
    let tempCreatedAt = new Date(response.data.createdAt);
    setCreatedAtHour(formatTime(tempCreatedAt));

    // Data MutasiStok
    setNoBuktiMutasiStok(response.data.noBuktiMutasiStok);
    setTglMutasiStok(formatDate(response.data.tglMutasiStok));
    setKodeCOA(
      response.data.coa &&
        `${response.data.coa.kodeCOA} - ${response.data.coa.namaCOA}`
    );
    setKeterangan(response.data.keterangan);

    // Data Total
    setTotal(response.data.total);

    const response2 = await axios.post(
      `${tempUrl}/mutasiStokChildsByMutasiStok`,
      {
        mutasiStokId: response.data.id,
        kodeCabang: user.cabang.id,
        _id: user.id,
        token: user.token,
      }
    );
    setMutasiStoksChildData(response2.data);
    setJumlahItem(response2.data.length);
    setLoading(false);
  };

  const deleteMutasiStok = async (id) => {
    setLoading(true);
    try {
      await axios.post(`${tempUrl}/deleteMutasiStok/${id}`, {
        _id: user.id,
        token: user.token,
      });
      navigate("/daftarMutasiStok");
    } catch (error) {
      alert(error.response.data.message);
    }
    setLoading(false);
  };

  const handleGeneratePdf = () => {
    const doc = new jsPDF({
      format: "a4",
      unit: "px",
    });

    doc.html(reportTemplateRef.current, {
      async callback(doc) {
        window.open(URL.createObjectURL(doc.output("blob")));
      },
      html2canvas: { scale: 0.44 },
    });
  };

  if (loading) {
    return <Loader />;
  }

  const textRight = {
    textAlign: screenSize >= 650 && "right",
  };

  return (
    <Container>
      <h3>Transaksi</h3>
      <h5 style={{ fontWeight: 400 }}>Mutasi Stok</h5>
      <hr />
      <Button
        variant="outlined"
        color="secondary"
        onClick={() => navigate("/daftarMutasiStok")}
        sx={{ marginLeft: 2, marginTop: 4 }}
      >
        {"< Kembali"}
      </Button>

      <Box sx={downloadButtons}>
        <ButtonGroup variant="outlined" color="secondary">
          <Button
            color="primary"
            startIcon={<SearchIcon />}
            onClick={() => {
              setPreviewPdf(!previewPdf);
            }}
          >
            CETAK
          </Button>
        </ButtonGroup>
      </Box>

      <Box sx={buttonModifierContainer}>
        {isEditable && (
          <>
            <ButtonModifier
              id={id}
              kode={"test"}
              addLink={null}
              editLink={`/daftarMutasiStok/mutasiStok/${id}/edit`}
              deleteUser={deleteMutasiStok}
              nameUser={noBuktiMutasiStok}
            />
          </>
        )}
      </Box>

      {previewPdf && (
        <div>
          <Button
            variant="outlined"
            startIcon={<PrintIcon />}
            onClick={handleGeneratePdf}
          >
            CETAK
          </Button>
          <div ref={reportTemplateRef} style={cetakContainerKwitansi}>
            <p style={cetakText}>{setting.namaPerusahaan}</p>
            <p style={cetakText}>
              {setting.alamatPerusahaan} ({setting.kabupatenPerusahaan}){" "}
              {setting.kotaPerusahaan}
            </p>
            <p style={cetakText}>TELP. {setting.teleponPerusahaan}</p>
            <p style={cetakCenter}>
              <b>NOTA MUTASI STOK</b>
            </p>
            <div style={{ display: "flex", marginTop: "10px" }}>
              <div style={{ flex: 1 }}>
                <div style={{ display: "flex" }}>
                  <div style={{ flex: 1 }}>
                    <span>No. Bukti</span>
                  </div>
                  <div style={{ flex: 2 }}>
                    <span>: {noBuktiMutasiStok}</span>
                  </div>
                </div>

                <div style={{ display: "flex" }}>
                  <div style={{ flex: 1 }}>
                    <span>Tgl. / J.Tempo</span>
                  </div>
                  <div style={{ flex: 2 }}>
                    <span>: {tglMutasiStok}</span>
                  </div>
                </div>
              </div>
              <div style={{ flex: 1 }}>
                <div style={{ display: "flex" }}>
                  <div style={{ flex: 1 }}>
                    <span>Terima Dari</span>
                  </div>
                  <div style={{ flex: 2 }}>
                    <span>:</span>
                  </div>
                </div>
              </div>
            </div>

            <table class="table" id="table">
              <thead>
                <tr>
                  <th style={{ border: "1px solid black" }}>KODE</th>
                  <th style={{ border: "1px solid black" }}>NAMA BARANG</th>
                  <th style={{ border: "1px solid black" }}>QTY.</th>
                  <th style={{ border: "1px solid black" }}>SAT.</th>
                  <th style={{ border: "1px solid black" }}>H. SATUAN</th>
                  <th style={{ border: "1px solid black" }}>SUBTOTAL</th>
                </tr>
              </thead>
              <tbody>
                {mutasiStoksChildData.map((user, index) => (
                  <tr key={user.id}>
                    <td style={{ border: "1px solid black" }}>
                      {user.stok.kodeStok}
                    </td>
                    <td style={{ border: "1px solid black" }}>
                      {user.stok.namaStok}
                    </td>
                    <td
                      style={{ border: "1px solid black", textAlign: "right" }}
                    >
                      {user.quantity.toLocaleString("de-DE")}
                    </td>
                    <td style={{ border: "1px solid black" }}>
                      {user.stok.satuanKecilStok}
                    </td>
                    <td
                      style={{ border: "1px solid black", textAlign: "right" }}
                    >
                      {user.hargaSatuan.toLocaleString("de-DE")}
                    </td>
                    <td
                      style={{ border: "1px solid black", textAlign: "right" }}
                    >
                      {user.totalMutasiStokChild.toLocaleString("de-DE")}
                    </td>
                  </tr>
                ))}

                <tr style={cetakTableTotalTerakhir}>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <span>Netto</span>
                      <span>:</span>
                    </div>
                  </td>
                  <td style={{ textAlign: "right" }}>
                    {total.toLocaleString("de-DE")}
                  </td>
                </tr>
              </tbody>
            </table>

            <div style={{ display: "flex", textAlign: "center" }}>
              <div style={{ flex: 1 }}>
                <div>
                  <p>Bag. Mutasi Stok</p>
                  <p style={{ marginTop: "60px" }}>( {user.username} )</p>
                </div>
              </div>
              <div style={{ flex: 1 }}>
                <div>
                  <p>Mengetahui,</p>
                  <div style={{ marginTop: "60px" }}>
                    <span>(</span>
                    <span style={{ marginLeft: "140px" }}>)</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      <Form>
        <Card>
          <Card.Header>Data Mutasi Stok</Card.Header>
          <Card.Body>
            <Box sx={textFieldContainer}>
              <Box sx={textFieldWrapper}>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        No. Bukti :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control value={noBuktiMutasiStok} disabled />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Tanggal :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control value={tglMutasiStok} disabled />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Jumlah Item :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control value={jumlahItem} disabled />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
              </Box>
              <Box sx={[textFieldWrapper, secondWrapper]}>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Kode COA :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control value={kodeCOA} disabled />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Keterangan :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control value={keterangan} disabled />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
              </Box>
            </Box>
          </Card.Body>
        </Card>
      </Form>

      <Box sx={tableChildWrapper}>
        <ShowTableMutasiStokChild id={id} currentPosts={currentPosts} />
      </Box>

      <Card style={{ marginTop: 10 }}>
        <Card.Header>Data Total</Card.Header>
        <Card.Body>
          <Box sx={textFieldContainer}>
            <Box sx={textFieldWrapper}>
              <Row>
                <Col>
                  <Form.Group
                    as={Row}
                    className="mb-3"
                    controlId="formPlaintextPassword"
                  >
                    <Form.Label column sm="5" style={textRight}>
                      Total :
                    </Form.Label>
                    <Col sm="7">
                      <NumericFormat
                        disabled
                        value={total}
                        decimalSeparator={","}
                        thousandSeparator={"."}
                        customInput={Form.Control}
                      />
                    </Col>
                  </Form.Group>
                </Col>
              </Row>
            </Box>
            <Box sx={[textFieldWrapper, secondWrapper]}></Box>
          </Box>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default TampilMutasiStok;

const buttonModifierContainer = {
  mt: 4,
  mb: 4,
  display: "flex",
  flexWrap: "wrap",
  justifyContent: "center",
};

const tableContainer = {
  pt: 4,
  display: "flex",
  justifyContent: "center",
};

const textFieldContainer = {
  display: "flex",
  flexDirection: {
    xs: "column",
    sm: "row",
  },
};

const textFieldWrapper = {
  display: "flex",
  flex: 1,
  flexDirection: "column",
  maxWidth: {
    md: "40vw",
  },
};

const secondWrapper = {
  marginLeft: {
    sm: 4,
  },
  marginTop: {
    sm: 0,
    xs: 4,
  },
};

const tableChildWrapper = {
  mt: 4,
  height: "400px",
  overflowY: "auto",
  border: "1px solid #e0e0e0",
};

const downloadButtons = {
  mt: 4,
  mb: 4,
  display: "flex",
  flexWrap: "wrap",
  justifyContent: "center",
};

const cetakContainerKwitansi = {
  fontSize: "14px",
  letterSpacing: "0.01px",
  fontFamily: "sans-serif",
  // width: "330px",
  padding: "20px",
  // marginLeft: "35px",
  marginLeft: "15px",
};

const cetakCenter = {
  // fontSize: "12px",
  fontSize: "14px",
  textAlign: "center",
  marginTop: "0px",
  marginBottom: "0px",
};

const cetakText = {
  // fontSize: "12px",
  fontSize: "14px",
  marginTop: "0px",
  marginBottom: "0px",
};

const cetakTableTotal = {
  border: "1px solid white",
  borderLeft: "1px solid black",
  borderRight: "1px solid black",
  height: "10px",
  lineHeight: "10px",
  padding: "0 0px",
};

const cetakTableTotalTerakhir = {
  border: "1px solid white",
  borderLeft: "1px solid black",
  borderRight: "1px solid black",
  borderBottom: "1px solid black",
  height: "10px",
  lineHeight: "10px",
  padding: "0 0px",
};
